enum ProductSearchMatch {
  CATEGORIES = 'CATEGORIES',
  TYPES = 'TYPES',
  PRODUCTS = 'PRODUCTS',
  NO = 'NO',
  ALL = 'ALL',
}

export { ProductSearchMatch };
